import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-foreground-950 text-background-100">
      <div className="mx-auto grid grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-8 md:py-14">
        <div className="md:col-span-2">
          <div className="mb-4 flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-open-line text-xl" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">双女漫</span>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-background-300">
            专注双女主剧情的韩漫在线阅读平台，汇集校园、奇幻、恋爱、悬疑等多样题材，免费浏览最新章节，
            为喜爱双女主的读者提供舒适稳定的阅读体验。
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">快速导航</h4>
          <ul className="space-y-2 text-sm text-background-300">
            <li><Link to="/" className="transition-colors hover:text-primary-300">首页</Link></li>
            <li><Link to="/category" className="transition-colors hover:text-primary-300">漫画分类</Link></li>
            <li><Link to="/search" className="transition-colors hover:text-primary-300">搜索结果</Link></li>
            <li><Link to="/about" className="transition-colors hover:text-primary-300">关于我们</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">联系我们</h4>
          <ul className="space-y-2 text-sm text-background-300">
            <li className="flex items-center gap-2"><i className="ri-mail-line" /> support@shuangnv-comic.example</li>
            <li className="flex items-center gap-2"><i className="ri-customer-service-2-line" /> 周一至周五 10:00 - 18:00</li>
            <li className="flex items-center gap-2"><i className="ri-map-pin-line" /> 首尔特别市 麻浦区 读书街 12</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="mx-auto flex flex-col gap-3 px-4 py-6 text-xs text-background-400 md:flex-row md:items-center md:justify-between md:px-8">
          <p>© 2026 双女漫 韩漫免费漫画在线观看阅读双女主 · 本站内容均为演示样例，版权归各原作者所有。</p>
          <p className="flex items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-primary-300">版权声明</Link>
            <Link to="/about" className="transition-colors hover:text-primary-300">免责声明</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}